<template>
  <div ref="printMe" class="container-fluid page-title">
    <!-- <Labels :title="title" :main="desc" /> -->
    <div class="row starter-main">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="@/assets/images/svg-img/finance-coin.svg"
                alt=""
              />
              <div class="text">
                <h5 class="title">Profitability</h5>
                <span class="subtitle">Last Updated: Yesterday</span>
              </div>
            </div>
          </div>
          <!-- <div class="bg-label">
            <div class="header-top">
              <h6 class="m-0 text-alert">
                <img src="../../assets/images/svg-img/alert-finance.svg" />
                EBITDA margin is decreasing yoy due to increasing BPP and
                foreign exchange loss"
              </h6>
              <div class="card-header-right-icon">
                <DropDown1 />
              </div>
            </div>
          </div> -->
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="">
                  <div
                    v-for="(item, id) in leftChart"
                    :key="id"
                    style="cursor: pointer"
                    :class="{ clicked: item.clicked }"
                    class="card card_white mb_12"
                    @click="detailItem(item)"
                  >
                    <div class="sub_title_2">
                      {{ item.metricName }} {{ item.currency }}
                    </div>
                    <div
                      style="justify-content: space-between"
                      class="d-flex align-items-center"
                    >
                      <div class="data_text">
                        {{ convertCurrency(item.value) }} {{ item.unit }}
                      </div>
                      <div
                        style="flex: 1; text-align: right"
                        class="d-flex ms-2"
                      >
                        <div
                          v-if="item.achievement !== null"
                          class="d-inline-flex align-items-center me-2"
                          :class="
                            item.achievementStatus === 'DOWN'
                              ? 'badge_red'
                              : 'badge_green'
                          "
                        >
                          <IconSvg
                            :color="
                              item.achievementStatus === 'DOWN'
                                ? 'red'
                                : 'green'
                            "
                            :type="
                              item.achievementStatus === 'DOWN'
                                ? 'chart_down'
                                : 'chart_up'
                            "
                          />
                          <div
                            class="data_detil"
                            :style="
                              item.achievementStatus === 'DOWN'
                                ? 'color: red'
                                : 'color:green'
                            "
                          >
                            {{ item.achievement }}
                          </div>
                        </div>
                        <div
                          v-if="item.trendStatus !== null"
                          class="d-inline-flex align-items-center"
                          :class="
                            item.trendStatus === 'DOWN'
                              ? 'badge_red'
                              : 'badge_green'
                          "
                        >
                          <IconSvg
                            :color="
                              item.trendStatus === 'DOWN' ? 'red' : 'green'
                            "
                            :type="
                              item.trendStatus === 'DOWN'
                                ? 'arrow_down'
                                : 'arrow_up'
                            "
                          />
                          <div
                            class="data_detil"
                            :style="
                              item.trendStatus === 'DOWN'
                                ? 'color: red'
                                : 'color:green'
                            "
                          >
                            {{ item.trend }}
                          </div>
                        </div>
                      </div>
                      <div class="d-inline-flex align-items-center me-2">
                        <apexchart
                          width="120"
                          height="50"
                          type="line"
                          :options="options4"
                          :series="series4"
                        ></apexchart>
                      </div>
                    </div>
                    <div
                      v-if="item.metricId !== 'REVENUE'"
                      style="color: #7a7a7a; font-size: small"
                    >
                      87,6% of Revenue
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="header-right-chart">
                  <div class="container-header">
                    <div class="text">
                      <h4 class="title-chart-right">
                        {{ titleProfit }} ({{ unitProfit }})
                      </h4>
                    </div>
                  </div>
                  <div class="card-header-right">
                    <div class="text-end">
                      <button
                        @click="monthly"
                        class="btn btn-square btn-disable"
                        :class="{ 'btn-info': !isActiveMonth }"
                        type="button"
                        title="btn btn-square btn-primary"
                      >
                        Month
                      </button>
                      <button
                        @click="monthly"
                        :class="{ 'btn-info': isActiveMonth }"
                        class="btn btn-square btn-disable m-r-10"
                        type="button"
                        title="btn btn-square btn-primary"
                      >
                        Year
                      </button>
                      <button
                        @click="cumulative"
                        class="btn btn-square"
                        :class="{ 'btn-info': !isActiveCumulative }"
                        type="button"
                        title="btn btn-square btn-disable btn-primary"
                      >
                        Non-Cumulative
                      </button>
                      <button
                        @click="cumulative"
                        :class="{ 'btn-info': isActiveCumulative }"
                        class="btn btn-square btn-disable m-r-10"
                        type="button"
                        title="btn btn-square btn-primary"
                      >
                        Cumulative
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="m-t-25"
                  style="justify-content: space-between; display: flex"
                >
                  <div>
                    <label>Holding/Subholding</label>
                    <multiselect
                      v-model="instanceId"
                      placeholder="Select Instance"
                      label="label"
                      track-by="value"
                      :options="dataInstance"
                      :multiple="false"
                      :taggable="false"
                    ></multiselect>
                    <!-- <select
                      v-model="instanceId"
                      class="custom-dropdown form-select"
                    >
                      <option
                        v-for="(option, key) in dataInstance"
                        :key="key"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select> -->
                  </div>
                  <div class="m-r-15 m-t-20">
                    <div
                      v-for="(item, id) in dataCheckbox"
                      :key="id"
                      class="d-flex flex-row-reverse align-items-center"
                    >
                      <div>
                        <input
                          class="form-check-input custom_checkbox_revenue"
                          :style="{
                            backgroundColor: item.color,
                            borderColor: item.color,
                          }"
                          type="checkbox"
                          :value="item.id"
                          v-model="isCheckedProfit"
                        />
                      </div>
                      <div class="custom_checkbox_texts">{{ item.name }}</div>
                    </div>
                  </div>
                </div>
                <div class="card-body m-t-25">
                  <apexchart
                    height="650"
                    width="100%"
                    type="bar"
                    :options="options3"
                    :series="series3"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="@/assets/images/svg-img/finance-coin.svg"
                alt=""
              />
              <div class="text">
                <h5 class="title">Cash Management</h5>
                <span class="subtitle">Last Updated: Yesterday</span>
              </div>
            </div>
          </div>
          <!-- <div class="bg-label">
            <div class="header-top">
              <h6 class="m-0 text-alert">
                <img src="../../assets/images/svg-img/alert-finance.svg" />
                Overall healthy financial indicators, EBITDA is below RKAP
                target.
              </h6>
              <div class="card-header-right-icon">
                <DropDown1 />
              </div>
            </div>
          </div> -->
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="container-cash-cart">
                  <div
                    v-for="(item, id) in dataProfit"
                    :key="id"
                    style="padding: 3%"
                    class="item card card_white mb_12"
                  >
                    <div class="sub_title_2">
                      {{ item.metricName }}
                    </div>
                    <div
                      style="justify-content: space-between"
                      class="d-flex align-items-center"
                    >
                      <div class="data_text">
                        {{ convertCurrency(item.value) }} {{ item.unit }}
                      </div>
                      <div
                        style="flex: 1; text-align: right"
                        class="d-flex ms-2"
                      >
                        <div
                          v-if="item.trendStatus !== null"
                          class="d-inline-flex align-items-center me-2"
                          :class="
                            item.trendStatus === 'DOWN'
                              ? 'badge_red'
                              : 'badge_green'
                          "
                        >
                          <IconSvg
                            :color="
                              item.trendStatus === 'DOWN' ? 'red' : 'green'
                            "
                            :type="
                              item.trendStatus === 'DOWN'
                                ? 'arrow_down'
                                : 'arrow_up'
                            "
                          />
                          <div
                            class="data_detil"
                            :style="
                              item.trendStatus === 'DOWN'
                                ? 'color: red'
                                : 'color:green'
                            "
                          >
                            {{ item.trend }}
                          </div>
                        </div>
                        <div
                          v-if="item.achievementStatus !== null"
                          class="d-inline-flex align-items-center"
                          :class="
                            item.achievementStatus === 'DOWN'
                              ? 'badge_red'
                              : 'badge_green'
                          "
                        >
                          <IconSvg
                            :color="
                              item.achievementStatus === 'DOWN'
                                ? 'red'
                                : 'green'
                            "
                            :type="
                              item.achievementStatus === 'DOWN'
                                ? 'chart_down'
                                : 'chart_up'
                            "
                          />
                          <div
                            class="data_detil"
                            :style="
                              item.achievementStatus === 'DOWN'
                                ? 'color: red'
                                : 'color:green'
                            "
                          >
                            {{ item.achievement }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="color: #7a7a7a; font-size: small">
                      {{ item.description }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="header-right-chart">
                  <div class="container-header">
                    <div class="text">
                      <h6 class="title-chart-right">
                        DAILY CASH BALANCE TREND (IDR)
                      </h6>
                      <label>Holding/Subholding</label>
                      <multiselect
                        v-model="instanceIdCash"
                        placeholder="Select Instance"
                        label="label"
                        track-by="value"
                        :options="dataInstance"
                        :multiple="false"
                        :taggable="false"
                      ></multiselect>
                      <!-- <select
                        v-model="instanceIdCash"
                        class="custom-dropdown form-select"
                      >
                        <option
                          v-for="(option, key) in dataInstance"
                          :key="key"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select> -->
                    </div>
                  </div>
                  <div class="card-header-right">
                    <div class="text-end">
                      <div>
                        <div
                          v-for="(item, id) in dataCheckboxCash"
                          :key="id"
                          class="d-flex flex-row-reverse align-items-center"
                        >
                          <div>
                            <input
                              class="form-check-input custom_checkbox_revenue"
                              :style="{
                                backgroundColor: item.color,
                                borderColor: item.color,
                              }"
                              type="checkbox"
                              :value="item.id"
                              v-model="isCheckedCash"
                            />
                          </div>
                          <div class="custom_checkbox_texts">
                            {{ item.name }}
                          </div>
                        </div>
                        <!-- <div class="d-flex flex-row-reverse align-items-center">
                          <div>
                            <input
                              class="form-check-input custom_checkbox_kwh"
                              type="checkbox"
                              disabled
                              v-model="isChecked"
                            />
                          </div>
                          <div class="custom_checkbox_texts">
                            Available Cash
                          </div>
                        </div>
                        <div class="d-flex flex-row-reverse align-items-center">
                          <div>
                            <input
                              class="form-check-input custom_checkbox_connect"
                              type="checkbox"
                              disabled
                              v-model="isChecked"
                            />
                          </div>
                          <div class="custom_checkbox_texts">
                            Restricted Cash
                          </div>
                        </div> -->
                        <div class="checkbox-solid-primary">
                          <label class="m-r-5 custom_checkbox_texts"
                            >Minimum Cash Balance</label
                          >
                          <span style="color: red; font-weight: bold"
                            >......</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="justify-content: space-between; display: flex"
                ></div>
                <div>
                  <apexchart
                    height="215"
                    width="100%"
                    type="bar"
                    :options="optionsCashChart"
                    :series="cashChartData"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="@/assets/images/svg-icon/Money.svg"
                alt=""
              />
              <div class="text">
                <h5 class="title">Asset Management</h5>
                <span class="subtitle">Last Updated: Yesterday</span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div
              v-for="(item, id) in dataAssetManagement"
              :key="id"
              style="padding: 7%"
              class="card card_white"
            >
              <div class="m-b-20 sub_title_2">
                {{ item.metricName }} {{ getSymbol(item.currency) }}
              </div>
              <div
                style="justify-content: space-between"
                class="d-flex align-items-center"
              >
                <div class="data_text">
                  {{ convertCurrency(item.value) }} {{ item.unit }}
                </div>
                <div style="flex: 1; text-align: right" class="d-flex ms-2">
                  <div
                    v-if="item.achievementStatus !== null"
                    class="d-inline-flex align-items-center me-2"
                    :class="
                      item.achievementStatus === 'DOWN'
                        ? 'badge_red'
                        : 'badge_green'
                    "
                  >
                    <IconSvg
                      :color="
                        item.achievementStatus === 'DOWN' ? 'red' : 'green'
                      "
                      :type="
                        item.achievementStatus === 'DOWN'
                          ? 'chart_down'
                          : 'chart_up'
                      "
                    />
                    <div
                      class="data_detil"
                      :style="
                        item.achievementStatus === 'DOWN'
                          ? 'color: red'
                          : 'color:green'
                      "
                    >
                      3,2%
                    </div>
                  </div>
                  <div
                    v-if="item.trendStatus !== null"
                    class="d-inline-flex align-items-center"
                    :class="
                      item.totalPercent === 'DOWN' ? 'badge_red' : 'badge_green'
                    "
                  >
                    <IconSvg
                      :color="item.trendStatus === 'DOWN' ? 'red' : 'green'"
                      :type="
                        item.trendStatus === 'DOWN' ? 'arrow_down' : 'arrow_up'
                      "
                    />
                    <div
                      class="data_detil"
                      :style="
                        item.trendStatus === 'DOWN'
                          ? 'color: red'
                          : 'color:green'
                      "
                    >
                      4,6%
                    </div>
                  </div>
                </div>
                <div style="color: #7a7a7a; font-size: small">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import FinanceService from "@/services/finance/finance";
import ReferenceService from "@/services/reference/reference";
import IconSvg from "@/components/IconSvg.vue";
import DropDown1 from "@/components/dropdown/DropDown1";
import { currencyFormatNumberComma } from "@/utils/helper";
import html2canvas from "html2canvas";

const getRef = ReferenceService.build();
const getFinance = FinanceService.build();
export default {
  components: {
    IconSvg,
    DropDown1,
  },
  data() {
    return {
      selectedOption: null,
      options: [
        { id: 1, name: "Option 1" },
        { id: 2, name: "Option 2" },
        { id: 3, name: "Option 3" },
        // Add more options as needed
      ],
      instanceId: { label: "Konsolidasi", value: "consolidated" },
      instanceIdCash: { label: "Konsolidasi", value: "consolidated" },
      dataInstance: [],
      cashChartData: [],
      isChecked: true,
      isCheckedProfit: [],
      isCheckedCash: [],
      isCheckedTarif: true,
      isCheckedRevenue: true,
      isCheckedSubs: true,
      isCheckedConn: true,
      isCheckedKwh: true,
      isActiveMonth: false,
      isActiveCumulative: false,
      isActive: false,
      title: "Finance",
      dataAssetManagement: [],
      idSummary: "REVENUE",
      titleProfit: "",
      unitProfit: "",
      desc: [{ childMsg: "Foo" }, { childMsg: "Bar" }],
      optionsCashChart: {
        chart: {
          type: "bar",
          height: 300,
          stacked: true,
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            top: 8,
            left: 0,
            blur: 10,
            color: "#7064F5",
            opacity: 0.1,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "25px",
            borderRadius: 0,
          },
        },
        grid: {
          show: true,
          borderColor: "var(--chart-border)",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          dashArray: 0,
          lineCap: "butt",
          colors: "#fff",
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
        },
        states: {
          hover: {
            filter: {
              type: "darken",
              value: 1,
            },
          },
        },
        colors: [],
        yaxis: {
          tickAmount: 3,
          labels: {
            show: true,
            style: {
              fontFamily: "Rubik, sans-serif",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        labels: [
          "Feb 9",
          "Feb 10",
          "Feb 11",
          "Feb 12",
          "Feb 13",
          "Feb 14",
          "Feb 15",
        ],
        xaxis: {
          labels: {
            style: {
              fontFamily: "Rubik, sans-serif",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        states: {
          hover: {
            filter: {
              type: "darken",
              value: 1,
            },
          },
        },
        responsive: [
          {
            breakpoint: 1661,
            options: {
              chart: {
                height: 290,
              },
            },
          },
          {
            breakpoint: 767,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "35px",
                },
              },
              yaxis: {
                labels: {
                  show: false,
                },
              },
            },
          },
          {
            breakpoint: 481,
            options: {
              chart: {
                height: 200,
              },
            },
          },
          {
            breakpoint: 420,
            options: {
              chart: {
                height: 170,
              },
              plotOptions: {
                bar: {
                  columnWidth: "40px",
                },
              },
            },
          },
        ],
      },
      options3: {
        chart: {
          type: "bar",
          height: 300,
          stacked: true,
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            top: 8,
            left: 0,
            blur: 10,
            color: "#7064F5",
            opacity: 0.1,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "25px",
            borderRadius: 0,
          },
        },
        grid: {
          show: true,
          borderColor: "var(--chart-border)",
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
        },
        states: {
          hover: {
            filter: {
              type: "darken",
              value: 1,
            },
          },
        },
        colors: [],
        yaxis: {
          tickAmount: 3,
          labels: {
            show: true,
            style: {
              fontFamily: "Rubik, sans-serif",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        xaxis: {
          categories: [],
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        states: {
          hover: {
            filter: {
              type: "darken",
              value: 1,
            },
          },
        },
        responsive: [
          {
            breakpoint: 1661,
            options: {
              chart: {
                height: 290,
              },
            },
          },
          {
            breakpoint: 767,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "35px",
                },
              },
              yaxis: {
                labels: {
                  show: false,
                },
              },
            },
          },
          {
            breakpoint: 481,
            options: {
              chart: {
                height: 200,
              },
            },
          },
          {
            breakpoint: 420,
            options: {
              chart: {
                height: 170,
              },
              plotOptions: {
                bar: {
                  columnWidth: "40px",
                },
              },
            },
          },
        ],
      },
      cashChart: [],
      series3: [],
      dataProfit: [],
      leftChart: [],
      options4: {
        chart: {
          width: 120,
          height: 120,
          type: "line",
          toolbar: {
            show: false,
          },
          offsetY: 10,
          dropShadow: {
            enabled: true,
            enabledOnSeries: undefined,
            top: 6,
            left: 0,
            blur: 6,
            color: "#00a3e9",
            opacity: 0.3,
          },
        },
        grid: {
          show: false,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 1,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            colorStops: [
              {
                offset: 0,
                color: "red",
                opacity: 1,
              },
              {
                offset: 20,
                color: "red",
                opacity: 1,
              },
              {
                offset: 30,
                color: "#b377d0",
                opacity: 1,
              },
              {
                offset: 65,
                color: "#7064f5",
                opacity: 1,
              },
              {
                offset: 70,
                color: "#b778cf",
                opacity: 1,
              },
              {
                offset: 80,
                color: "red",
                opacity: 1,
              },
              {
                offset: 100,
                color: "#a873d7",
                opacity: 1,
              },
            ],
          },
        },
        colors: ["var(--theme-deafult)"],
        stroke: {
          width: 2,
          curve: "smooth",
        },
        labels: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep"],
        markers: {
          size: 0,
        },
        xaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          marker: {
            show: false,
          },
          x: {
            show: false,
          },
          y: {
            show: false,
            labels: {
              show: false,
            },
          },
        },
        responsive: [
          {
            breakpoint: 1790,
            options: {
              chart: {
                width: 100,
                height: 100,
              },
            },
          },
          {
            breakpoint: 1661,
            options: {
              chart: {
                width: "100%",
                height: 100,
              },
            },
          },
        ],
      },
      series4: [
        {
          name: "Sales",
          data: [23, 23, 20, 20, 32, 32, 40, 32, 32, 25, 30, 30],
        },
      ],
      dataCheckbox: [],
      dataTemp: [],
      dataCheckboxCash: [],
      dataTempCash: [],
    };
  },
  created() {
    this.getData();
    this.getDataCash();
    this.getProfitChart();
    this.getAssetManagement();
    this.getDataCashChart();
    this.getComboInstance();
  },
  watch: {
    isCheckedCash(x) {
      const filter = this.dataTempCash.filter((item) => x.includes(item.id));
      this.cashChartData = filter;
    },
    isCheckedProfit(x) {
      const filter = this.dataTemp.filter((item) => x.includes(item.id));
      this.series3 = filter;
    },
    instanceId() {
      this.instanceId = this.instanceId;
      setTimeout(() => {
        this.getProfitChart();
      }, 100);
    },
    instanceIdCash() {
      this.instanceIdCash = this.instanceIdCash;
      this.getDataCashChart();
    },
  },
  mounted() {
    this.$store.commit("updateJudulHalaman", "");
  },
  methods: {
    async print() {
      const el = this.$refs.printMe;
      html2canvas(el).then((canvas) => {
        // Convert the canvas to a data URL and open it in a new tab
        const imageData = canvas.toDataURL();
        const image = new Image();
        image.src = imageData;
        const w = window.open();
        w.document.write(image.outerHTML);
      });
    },
    getSymbol(x) {
      return x !== null ? `(${x})` : "";
    },
    convertCurrency(x) {
      const str = x.toString();
      if (str.includes(".")) {
        const cnv = str.split(".")[0];
        let dotIndex = str.indexOf(".");
        const after = str.slice(dotIndex + 1);
        return currencyFormatNumberComma(cnv) + "." + after;
      } else {
        return str;
      }
    },
    async getComboInstance() {
      const res = await getRef.getRefHolding();
      const data = res.data.data;
      this.dataInstance = data;
    },
    detailItem(x) {
      this.leftChart.forEach((e) => {
        if (e.metricId === x.metricId) {
          e.clicked = true;
          this.idSummary = x.metricId;
          this.getProfitChart();
        } else {
          e.clicked = false;
        }
      });
    },
    async getDataCashChart() {
      const param = {
        instance: this.instanceIdCash.value,
      };
      const res = await getFinance.getDataCashChart(param);
      const data = res.data.data.values;
      let color = ["#C892F8", "#9780D9"];
      const result = data.map((el, index) => ({
        ...el,
        color: color[index],
      }));
      const item = data.map((obj) => obj.id);
      this.isCheckedCash = item;
      this.dataCheckboxCash = result;
      this.dataTempCash = result;
      this.cashChartData = result;
      // this.dataAssetManagement = data;
    },
    async getAssetManagement() {
      const res = await getFinance.getAssetManagement();
      const data = res.data.data;
      this.dataAssetManagement = data;
    },
    async getProfitChart() {
      const id = this.idSummary;
      const param = {
        instance: this.instanceId.value,
        period: this.isActiveMonth ? "annually" : "monthly",
        type: this.isActiveCumulative ? "cumulative" : "noncumulative",
      };
      const res = await getFinance.getDataProfitChart(param, id);
      const data = res.data;
      const value = data.data.values;
      // let dataArray = [
      //   "#C892F8",
      //   "#9780D9",
      //   "#9A9BF0",
      //   "#8099D9",
      //   "#92CAF8",
      //   "#C892F8",
      //   "#9780D9",
      //   "#9A9BF0",
      //   "#8099D9",
      //   "#92CAF8",
      // ];
      // const result = value.map((el, index) => ({
      //   ...el,
      //   color: dataArray[index],
      // }));
      this.dataCheckbox = value;
      this.titleProfit = data.data.name;
      this.unitProfit = data.data.currency;
      this.dataTemp = value;
      const label = value.map((obj) => obj.labels);
      // this.options3.labels = label[0];
      const item = value.map((obj) => obj.id);
      this.isCheckedProfit = item;
      this.series3 = value;
      this.options3 = { xaxis: { categories: label[0] } };
    },
    setNewKey(array, keyName) {
      array.forEach((obj) => {
        obj[keyName] = obj.name; // Extracting 'name' value and setting it to the new key
      });
    },
    async getDataCash() {
      const res = await getFinance.getDataCash();
      const data = res.data;
      this.dataProfit = data.data;
    },
    async getData() {
      const res = await getFinance.getDataProfit();
      const data = res.data.data;
      this.leftChart = data;
      this.detailItem(data[0]);
    },
    detailCash() {
      // this.$router.push({ name: "detail-cash" });
      this.$router.push({ name: "Cash Management" });
    },
    more() {
      // this.$router.push({ name: "detail-assets" });
      this.$router.push({ name: "Asset Management" });
    },
    profit() {
      // this.$router.push({ name: "detail-profit" });
      this.$router.push({ name: "Profit & Loss" });
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
      this.getProfitChart();
    },
    cumulative() {
      this.isActiveCumulative = !this.isActiveCumulative;
      this.getProfitChart();
    },
    toggleSwitch() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
<style scoped>
#logo-holder {
  position: relative;
}
#logo-holder .image,
#logo-holder .texts {
  transition: opacity 0.5s ease-in-out;
}
#logo-holder .image1,
#logo-holder .text1 {
  transition: opacity 0.5s ease-in-out;
}
#logo-holder .texts {
  position: absolute;
  font-size: 12px;
  top: 10px;
  left: 30px;
  opacity: 0;
}
#logo-holder .text1 {
  position: absolute;
  font-size: 12px;
  top: 10px;
  left: 90px;
  opacity: 0;
}

#logo-holder:hover .image {
  opacity: 1;
  margin-left: 60px;
}
#logo-holder:hover .image1 {
  opacity: 1;
  margin-left: 30px;
}
#logo-holder:hover .texts {
  opacity: 1;
  background-color: green;
  color: white;
  margin-right: 10px;
}
#logo-holder:hover .text1 {
  opacity: 1;
  background-color: green;
  color: white;
  margin-left: 7px;
}
.font-gray {
  color: #4e4e4e !important;
}
.title-left {
  white-space: normal;
  width: 155px;
}
.left-card {
  border: 1px solid #e5e7ed;
  border-radius: 8px;
  background-color: white;
  margin-bottom: 10px;
}
.title-chart-right {
  color: #4e4e4e;
  font-weight: bold;
}
.header-right-chart {
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
}
.custom-dropdown {
  background-color: #e6e6e6; /* Set the background color to gray */
  padding: 8px; /* Add padding for better appearance */
  border: none; /* Remove default border */
  border-radius: 4px; /* Add border radius for rounded corners */
  outline: none; /* Remove focus outline */
  /* Add any additional styles here */
}
/* .checkbox1 {
  background-color: #92caf8;
} */
.checkbox1 {
  display: none; /* Hide the default checkbox */
}

/* Style the label associated with the custom checkbox */
.checkbox1 + label {
  position: relative;
  padding-left: 25px; /* Adjust the padding to accommodate the custom checkbox */
  cursor: pointer;
}

/* Style the custom checkbox */
.checkbox1 + label::before {
  content: "";
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: #e0e0e0; /* Background color of the custom checkbox */
  border: 1px solid #ccc; /* Border color */
  border-radius: 4px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* Change background color when checked */
.checkbox1:checked + label::before {
  background-color: #92caf8; /* Background color when checked */
}
.container-cash-cart {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 0px;
}
.item {
  width: 48%; /* Each div takes up 50% of the container width */
}
.text-detail:hover {
  color: #16c7f9;
}
.fa.fa-angle-right {
  color: #16c7f9;
}
.btn-disable {
  background-color: #e9e9e9;
}
.profit-card {
  /* justify-content: center; */
  padding: 2%;
}
.page-wrapper .page-body-wrapper .page-title .row {
  align-items: normal !important;
}
.clicked {
  border-color: #00a3e9;
  background-color: #ecf9ff;
}
</style>
